import { InputField } from 'components/layout/form-fields/inputs/InputField';
import React from 'react';
import Dropdown from '../dropdown/Dropdown';
import Calendar from '../calendar/Calendar';
import { observer } from 'mobx-react';
import { CountryDropdown } from 'components/candidates/CountryDropdown';
import { UsersDropdown } from 'components/layout/form-fields/inputs/UsersDropdown';
import { ClientsDropdown } from 'components/layout/form-fields/inputs/ClientsDropdown';
import { JobRoleDropdown } from 'components/layout/form-fields/inputs/JobRoleDropdown';
import { JobPositionDropdown } from 'components/layout/form-fields/inputs/JobPositionDropdown';
import { Switch } from 'components/layout/form-fields/inputs/Switch';
import MultiDropdownGrouped from '../multi-dropdown-grouped/MultiDropdownGrouped';
import StageFilterDropdown from '../stage-filter-dropdown/StageFilterDropdown';
import MeModeToggle from './MeModeToggle';

function FilterBar({
	filters,
	onShowMore,
	appliedFilters,
	actions,
	showMineToggle = false,
	mineOn = false,
	onMineChange,
	showFiltersButton = true
}) {
	const filterComponents = {
		search: ({ key, label, name, value, onKeyPress, onChange }) => (
			<InputField
				autoFocus={true}
				className="has-text-left no-margin-bottom"
				field={name}
				type="search"
				icon="fa-search"
				placeholder={label}
				value={value}
				onKeyPress={onKeyPress}
				onValueChange={onChange}
				debounce
				debounceTime={400}
			/>
		),
		dropdown: ({ key, name, onChange, value, options, placeholder = '' }) => (
			<Dropdown
				key={key}
				value={value}
				name={name}
				onChange={onChange}
				options={options}
				placeholder={placeholder}
			/>
		),
		'multi-dropdown': ({
			key,
			name,
			onChange,
			value,
			options,
			getOptionLabel,
			placeholder = ' ',
			dropdownClassName,
			fitMenuToContent
		}) => (
			<MultiDropdownGrouped
				key={key}
				name={name}
				className={`ats-multi-dropdown ats-multi-dropdown-grouped react-select ${dropdownClassName || ''}`.trim()}
				isClearable
				placeholder={placeholder}
				options={options}
				getOptionLabel={getOptionLabel}
				onChange={e => onChange(e)}
				value={value}
				menuPlacement="auto"
				menuPosition="fixed"
				fitMenuToContent={fitMenuToContent}
			/>
		),
		'stage-filter-dropdown': ({
			key,
			name,
			onChange,
			value,
			options,
			placeholder = 'Stage',
			groups,
			stageToStatus,
			statusGroupMap,
			renderStage,
			renderValueIcon,
			getValueColor
		}) => (
			<StageFilterDropdown
				key={key}
				name={name}
				placeholder={placeholder}
				options={options}
				groups={groups}
				stageToStatus={stageToStatus}
				statusGroupMap={statusGroupMap}
				renderStage={renderStage}
				renderValueIcon={renderValueIcon}
				getValueColor={getValueColor}
				onChange={onChange}
				value={value}
			/>
		),
		calendar: ({ label, onChange, value }) => (
			<Calendar value={value} placeholder={label} onChange={onChange} />
		),
		switch: ({ id, value, onChange, activeLabel, inactiveLabel }) => (
			<Switch
				id={id}
				value={value}
				onValueChange={onChange}
				activeLabel={activeLabel}
				inactiveLabel={inactiveLabel}
			/>
		),
		'country-dropdown': ({
			value,
			onChange,
			placeholder = ' ',
			isMulti,
			isClearable
		}) => (
			<CountryDropdown
				isMulti={isMulti}
				value={value}
				placeholder={placeholder}
				onValueChange={onChange}
				isClearable={isClearable}
			/>
		),
		'user-dropdown': ({
			value,
			onChange,
			role,
			placeholder = ' ',
			isMulti,
			isClearable,
			minSearchChars
		}) => (
			<UsersDropdown
				value={value}
				isMulti={isMulti}
				placeholder={placeholder}
				role={role}
				minSearchChars={minSearchChars}
				onValueChange={onChange}
				isClearable={isClearable}
				showAvatar
			/>
		),
		'client-dropdown': ({
			value,
			onChange,
			placeholder = ' ',
			isClearable,
			isMulti
		}) => (
			<ClientsDropdown
				value={value}
				isMulti={isMulti}
				placeholder={placeholder}
				onValueChange={onChange}
				isClearable={isClearable}
			/>
		),
		'job-role-dropdown': ({ value, onChange, placeholder = ' ' }) => (
			<JobRoleDropdown
				isMulti
				includeLegacy
				value={value}
				placeholder={placeholder}
				styleVersion="ats"
				onValueChange={onChange}
			/>
		),
		'job-position-dropdown': ({
			value,
			onChange,
			placeholder = ' ',
			showOnlyOpenJobs
		}) => (
			<JobPositionDropdown
				value={value}
				placeholder={placeholder}
				styleVersion="ats"
				showOnlyOpenJobs={showOnlyOpenJobs}
				onValueChange={onChange}
			/>
		)
	};
	return (
		<div className="filter-bar-container">
			{filters?.map((f, index) =>
				filterComponents[f.type]({
					...f,
					key: index
				})
			)}

			{(showMineToggle || actions || (showFiltersButton && onShowMore)) && (
				<div className="filter-bar-actions">
					{showMineToggle && (
						<MeModeToggle value={mineOn} onChange={onMineChange} />
					)}
					{actions}
					{showFiltersButton && onShowMore ? (
						<button
							type="button"
							className="filter-drawer-btn"
							onClick={onShowMore}
							onMouseDown={e => {
								e.stopPropagation();
							}}>
							<img src="/ats/icons/filters-icon.svg" alt="" />
							<span>Filters</span>
							{appliedFilters?.length > 0 && (
								<span className="applied-filters-quantity">
									{appliedFilters.length}
								</span>
							)}
						</button>
					) : null}
				</div>
			)}
		</div>
	);
}

export default observer(FilterBar);
